import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueFullPage from "vue-fullpage.js";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "./assets/styles/container.scss";

const app = createApp(App);

app
  .use(router)
  .use(VueFullPage)
  .component("Swiper", Swiper)
  .component("SwiperSlide", SwiperSlide)
  .component("Multiselect", Multiselect)
  .mount("#app");
